import { injectable, inject } from 'inversify';

import { History } from '@vk-hr-tek/core/history';
import { RoleService } from '@vk-hr-tek/core/http';

import { EmployeesRouter } from '../../../employees/types';
import { modules } from '../../modules';

@injectable()
export class EmployeesRouterService implements EmployeesRouter {
  constructor(
    @inject(History) private history: History,
    @inject(RoleService) private readonly role: RoleService,
  ) {}

  goToList(query?: string) {
    if (!query || query === '?') {
      this.history.push(`/${this.role.get()}/${modules.employees.basename}`);
      return;
    }

    this.history.push({
      pathname: `/${this.role.get()}/${modules.employees.basename}`,
      search: query.startsWith('?') ? query : `?${query}`,
    });
  }
}
